import { useQuery } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import type { WellnessCheckAdditionalCategoriesResponse } from "../models/notes/wellness-check-additional-categories.model";

export const useWellnessCheckAdditionalCategories = () => {
	return useQuery({
		queryKey: ["participant-notes", "additional-categories"],

		queryFn: async (): Promise<WellnessCheckAdditionalCategoriesResponse> => {
			return EndpointsService.dataRetriever.getParticipantNotesAdditionalCategories();
		},
	});
};
